import {provider, useIsomorphicLayoutEffect} from '@sail/engine';
import React, {useContext, useMemo, useState} from 'react';

export type CreationDrawerHeaderInChildrenDetectorContextType = {
  register: () => () => void;
};

const CreationDrawerHeaderInChildrenDetectorContext =
  React.createContext<CreationDrawerHeaderInChildrenDetectorContextType | null>(
    null,
  );

export function useCreationDrawerHeaderInChildren() {
  const [count, setCount] = useState(0);

  const context = useMemo(
    () => ({
      register: () => {
        setCount((c) => c + 1);

        return () => {
          setCount((c) => c - 1);
        };
      },
    }),
    [],
  );

  return {
    hasCreationDrawerHeaderInChildren: count > 0,
    contextIntentForChildren: provider(
      CreationDrawerHeaderInChildrenDetectorContext,
      context,
    ),
    // We reset the context for headers to avoid false-detecting headers in children due to nested overlays
    contextIntentForHeader: provider(
      CreationDrawerHeaderInChildrenDetectorContext,
      null,
    ),
  };
}

export function useRegisterCreationDrawerHeaderInChildren() {
  const context = useContext(CreationDrawerHeaderInChildrenDetectorContext);

  useIsomorphicLayoutEffect(() => {
    return context?.register();
  }, [context]);
}
